import React, {useRef, useEffect} from "react"
import * as styles from "./music.module.css"
import VideoTiles from "./videoTiles"
import Section from "./section"

export default function Music() {
	return (
		<Section
			id="music"
			className={styles.music}
			wrapperClassName={styles.inner}
		>
			<h3>Featured Tracks</h3>
			<div className={styles.iFrameWrapper}>
				<iframe
					id="reelcrafter"
					title="Featured Tracks"
					width="100%"
					scrolling="no"
					frameBorder="0"
					src="https://play.reelcrafter.com/embed/537d8ef7-0d16-4bf5-9453-0da14e93e0e9"
				></iframe>
			</div>
			<h4>Rescores</h4>
			<VideoTiles
				videos={[
					{id: "ih4R8Y3kVGI", title: "Charge Rescore"},
					{id: "eBJkuwcUaE8", title: "Spring Rescore"},
					{id: "mEsXYY9bInM", title: "Elengard: Fantasy RPG Game"},
				]}
			></VideoTiles>

			<h4>Storytelling: My own videos</h4>
			<VideoTiles
				videos={[
					{id: "DLsOfd6BVO0", title: "Four & One: All the Versions of You"},
					{id: "MXbboxwS7tQ", title: "Three: What you saw"},
				]}
			></VideoTiles>
		</Section>
	)
}
